export default "__VITE_ASSET__0c772170__"